import React, { useState } from 'react'
import TableFilterTemplate from '../../shared/utils/TableFilterTemplate';
import { useGetAddedCourseLms } from '../../assets/nodeApi/getApi/getAdminApi';
import { Grid2, IconButton, Stack, Typography } from '@mui/material';
import { useLmsDropdownOptions } from './option/LsmOption';
import { Field } from 'formik';
import { IdAutoCompleteField } from '../../shared/components/formfields/IdAutoCompleteField';
import { AutoCompleteField } from '../../shared/components/formfields/AutoCompleteField';
import { useNavigate } from 'react-router-dom';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { useQueryClient } from "@tanstack/react-query";

const CourseLmsList = () => {
    const [courseMode, setCourseMode] = useState("");
    const [filters, setFilters] = useState({});
    const { data: lmsList, isLoading: isLmsLoading } = useGetAddedCourseLms(filters)
    const { lmsGrade, lmsPublication, lmsLangauge, lmsBoard, lmsCourses, lmsCourseTypeOptions } = useLmsDropdownOptions(
        {
            gradeFilter: { status: true },
            boardFilter: { status: true },
            publicationFilter: { status: true },
            languagesFilter: { status: true },
            courseFilter: { mode: courseMode }
        }
    )
    const navigate = useNavigate()
    const queryClient = useQueryClient();

    const lmsGradeOption =
        lmsList?.courses?.map((item, index) => ({
            id: item.course_id,
            label: item?.name,
            value: item?.name,
            sr_no: index + 1,
            ...item
        })) ?? [];


    const lmsColumns = [
        {
            field: "sr_no",
            headerName: "Sr No",
            flex: 0.5,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>
        },
        {
            field: "label",
            headerName: "Course Name",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>
        },
        {
            field: "course_type",
            headerName: "Course Type",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params?.value}</Typography>
        },
        {
            field: "grade",
            headerName: "Grade",
            flex: 0.8,
            valueGetter: (params) => params?.row?.grade?.name || '-',
            renderCell: (params) => <Typography variant="body2">{params?.row?.grade?.name}</Typography>
        },
        {
            field: "board",
            headerName: "Board",
            flex: 0.8,
            valueGetter: (params) => params?.row?.board?.name || '-',
            renderCell: (params) => <Typography variant="body2">{params?.row?.board?.name}</Typography>
        },
        {
            field: "language",
            headerName: "Language",
            flex: 0.8,
            valueGetter: (params) => params?.row?.language?.name || '-',
            renderCell: (params) => <Typography variant="body2">{params?.row?.language?.name}</Typography>
        },
        {
            field: "publication",
            headerName: "Publication",
            flex: 1,
            valueGetter: (params) => params?.row?.publication?.name || '-',
            renderCell: (params) => <Typography variant="body2">{params?.row?.publication?.name}</Typography>
        },
        {
            field: "level",
            headerName: "Level",
            flex: 0.8,
            valueGetter: (params) => params?.row?.level?.name || '-',
            renderCell: (params) => <Typography variant="body2">{params?.row?.level?.name}</Typography>
        },
        // {
        //     field: "actionsEdit",
        //     headerName: "Edit",
        //     flex: 1,
        //     renderCell: (params) => (
        //         <Stack direction="row" spacing={1}>
        //             <IconButton
        //                 onClick={() => {
        //                     navigate(`/admin/addlms/${params?.row?.course_id}`)
        //                 }}
        //                 size="small"
        //             >
        //                 <EditIcon color="text.primary" />
        //             </IconButton>
        //         </Stack>
        //     ),
        // },
        {
            field: "actionsView",
            headerName: "View",
            flex: 1,
            renderCell: (params) => (
                <Stack direction="row" spacing={1}>
                    <IconButton
                        onClick={() => {
                         
                            navigate(`/admin/editthreejslmslist/${params.row.course_id}`)
                        }}
                        size="small"
                    >
                        <VisibilityIcon />
                    </IconButton>
                </Stack>
            ),
        },




    ];

    return (
        <>
            <TableFilterTemplate
                title="Threejs List"
                columns={lmsColumns}
                rowsData={lmsGradeOption || []}
                isLoading={isLmsLoading}
                filterInitialValues={filters}
                filterReset={() => setFilters({})}
                onApplyFilters={(f) => setFilters(f)}
                renderFilterFields={() => (
                    <>

                        <Grid2 children size={12}>
                            <Field
                                name="mode"
                                component={AutoCompleteField}
                                label="Course Type Filter"
                                isRequired
                                options={lmsCourseTypeOptions.options}
                                onValueChange={(value) => {
                                    setCourseMode(value?.value);

                                }}

                            />
                        </Grid2>
                        <Grid2 children size={12}>
                            <Field
                                name="name"
                                component={AutoCompleteField}
                                options={lmsCourses.options}
                                label="Select Course"
                                isLoading={lmsCourses.isLoading}
                            />
                        </Grid2>
                        <Grid2 children size={12}>
                            <Field
                                name="gradeId"
                                component={IdAutoCompleteField}
                                options={lmsGrade.options}
                                label="Select Grade"
                                isLoading={lmsGrade.isLoading}
                            />
                        </Grid2>
                        <Grid2 children size={12}>
                            <Field
                                name="boardId"
                                component={IdAutoCompleteField}
                                options={lmsBoard.options}
                                label="Select Board"
                                isLoading={lmsBoard.isLoading}
                            />
                        </Grid2>
                        <Grid2 children size={12}>
                            <Field
                                name="languageId"
                                component={IdAutoCompleteField}
                                options={lmsLangauge.options}
                                label="Select Language"
                                isLoading={lmsLangauge.isLoading}
                            />
                        </Grid2>
                        <Grid2 children size={12}>
                            <Field
                                name="publicationId"
                                component={IdAutoCompleteField}
                                options={lmsPublication.options}
                                label="Select Publication"
                                isLoading={lmsPublication.isLoading}
                            />
                        </Grid2>
                    </>
                )}
            />
        </>
    )
}

export default CourseLmsList;
